import React from "react";
import {Select, SelectProps} from "antd";
import {debounce} from 'lodash';
import AccountApi from "../../Api/AccountApi";
import AccountDomain from "../../Domain/AccountDomain";

interface Props {
    value?: any,
    onChange?: (value: any) => void,
    selectProps?: SelectProps<any>,
    initialItems?: Array<AccountDomain>
}

interface State {
    value: any,
    loading: boolean,
    items: Array<AccountDomain>
}

class SelectMyAccount extends React.Component<Props, State> {

    state = {
        value: undefined,
        loading: false,
        items: []
    }

    static getDerivedStateFromProps(props: any, state: any) {
        const newState = {...state};
        if ('value' in props) {
            newState.value = props.value;
        }

        return newState;
    }

    componentDidMount() {
        if (this.props.initialItems) {
            this.setState({
                items: this.props.initialItems
            })
            return
        }

        this.fetchMyAccounts();
    }

    fetchMyAccounts = (query = {}) => {
        query = {
            offset: 0,
            limit: 1000,
            ...query
        }
        this.setState({loading: true});
        AccountApi.autocomplete(query)
            .then(response => {
                this.setState({
                    items: response.data
                })
            })
            .finally(() => {
                this.setState({loading: false});
            })
    };

    handleChange = (value: any) => {
        this.setState({value});
        this.props.onChange?.(value);
    };

    handleSearch = (value: any) => {
        const fetchMyAccounts = debounce(this.fetchMyAccounts, 500);
        fetchMyAccounts({query: value});
    }

    render() {
        const {selectProps,} = this.props;
        const {items, value} = this.state;
        return (
            <Select
                showSearch={true}
                filterOption={false}
                value={value}
                onChange={this.handleChange}
                onSearch={this.handleSearch}
                placeholder={"Chọn tài khoản quỹ"}
                {...selectProps}
            >
                {items.map((item: AccountDomain) => (
                    <Select.Option key={item.code} value={item.code}>{item.name} ({item.code})</Select.Option>
                ))}
            </Select>
        );
    }
}

export default SelectMyAccount;